import React from "react";
import { Box, Typography } from "@mui/material";
import { Medal } from "lucide-react";
import ChampionCard from "./ChampionCard";

const ChampionsWall = ({ champions = [] }) => (
  <Box>
    <Box sx={{ display: "flex", alignItems: "center", gap: "9px", mb: "14px" }}>
      <Medal size={16} color="hsl(40, 72%, 48%)" strokeWidth={2} />
      <Typography component="span" sx={{ fontSize: 14, fontFamily: "Segoe UI Semibold, sans-serif, system-ui", color: "hsl(150, 30%, 12%)" }}>
        Champions Wall
      </Typography>
      <Typography component="span" sx={{ fontSize: 12.5, fontFamily: "Segoe UI Regular, sans-serif, system-ui", color: "hsl(150, 10%, 46%)" }}>
        · record holders across the platform
      </Typography>
    </Box>
    <Box sx={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "16px" }}>
      {champions.map((champion) => (
        <ChampionCard key={champion.key} champion={champion} />
      ))}
    </Box>
  </Box>
);

export default ChampionsWall;
